import proxybase from './proxybase';

class IntranetService {
  getBulletins(body) {
    return proxybase
      .get(`/intranet/bulletins`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  createEditBulletin(body) {
    return proxybase
      .post(`/intranet/bulletin`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  markBulletinAsRead(body) {
    return proxybase
      .post(`/intranet/bulletin/mark-read`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  createInteraction(body) {
    return proxybase
      .post(`/intranet/interaction`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getAllInteractions(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.type) {
      queryParams.append('type', params.type);
    }
    const queryString = queryParams.toString();
    const url = `/intranet/interactions${queryString ? `?${queryString}` : ''}`;

    return proxybase
      .get(url)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  createUser(body) {
    return proxybase
      .post('/intranet/createStaffUser', body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
const intranetServiceInstance = new IntranetService();
export default intranetServiceInstance;
